/* eslint-disable import/no-extraneous-dependencies */
import {
  FaSearch,
  FaUser,
  FaUserCog,
  FaAddressBook,
  FaBuilding,
  FaUserMinus,
  FaBlender,
  FaGasPump,
  FaWarehouse,
  FaGreaterThanEqual,
  FaUserTie,
  FaUsersCog,
  FaUserCheck,
  FaCogs,
  FaUserClock,
  FaMoneyBill,
  FaFile,
  FaComments,
  FaTag,
  FaTags,
  FaBook,
  FaWrench,
} from 'react-icons/fa';

const iconMap = {
  search: FaSearch,
  user: FaUser,
  userCog: FaUserCog,
  addressBook: FaAddressBook,
  building: FaBuilding,
  userMinus: FaUserMinus,
  blender: FaBlender,
  gasPump: FaGasPump,
  warehouse: FaWarehouse,
  greaterThanEqual: FaGreaterThanEqual,
  userTie: FaUserTie,
  usersCog: FaUsersCog,
  userCheck: FaUserCheck,
  cogs: FaCogs,
  userClock: FaUserClock,
  moneyBill: FaMoneyBill,
  file: FaFile,
  comments: FaComments,
  tag: FaTag,
  tags: FaTags,
  book: FaBook,
  wrench: FaWrench,
};

export default iconMap;
